import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
  'en_us': require('./Language/en_us'),
  'zh_cn': require('./Language/zh_cn')
}

export default new VueI18n({
  locale: 'zh_cn',
  messages: messages
})



// WEBPACK FOOTER //
// ./src/Language/index.js